import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
import withStyles from 'isomorphic-style-loader/withStyles';

// Redux
import { connect } from 'react-redux';
import { doRemoveLogo, doUploadLogo } from '../../../../actions/siteadmin/manageLogo';
import { setLoaderStart, setLoaderComplete } from '../../../../actions/loader/loader';

// Translation
import { injectIntl } from 'react-intl';

// Asset
import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay';
import { logouploadDir } from '../../../../config';
import { photosShow } from '../../../../helpers/photosShow';
import { withQuery } from '../../../../hoc/withGraphql';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import cp from '../../../../components/commonStyle.css';
import s from './Uploader.css';
import messages from '../../../../locale/jsonMessages';

class Uploader extends React.Component {

  static propTypes = {
    logoUploaderLoading: PropTypes.bool,
    doRemoveLogo: PropTypes.any.isRequired,
    getLogoData: PropTypes.shape({
      loading: PropTypes.bool,
      getLogo: PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
      })
    })
  };

  static defaultProps = {
    profilePictureData: {
      loading: true
    },
    logoUploaderLoading: false
  };

  success = async (file, fromServer) => {
    const { doUploadLogo, getLogoData: { getLogo }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    let fileName = fromServer.file.filename,
      oldPicture = getLogo ? getLogo.value : null,
      filePath = fromServer.file.path;
    await doUploadLogo(fileName, filePath, oldPicture);
  }

  deleteImage = async () => {
    const { doRemoveLogo, getLogoData: { getLogo }, demoRestriction } = this.props;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await doRemoveLogo(getLogo?.value);
  }

  render() {
    const { getLogoData: { loading, getLogo }, doRemoveLogo, logoUploaderLoading } = this.props;
    const { formatMessage } = this.props.intl;
    let path = photosShow(logouploadDir);

    return (
      <div>
        <CommonImageDisplay
          loading={loading}
          image={getLogo?.value && path + getLogo?.value}
          isDefaultPic={getLogo?.value ? false : true}
          loader={logoUploaderLoading}
          deleteImage={this.deleteImage}
          isDelete={true}
        />

        <ImageUploadComponent
          defaultMessage={formatMessage(messages.clickHeretoUploadLogo)}
          componentConfig={{
            iconFiletypes: ['.jpg', '.png', '.jpeg'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: '/uploadLogo'
          }}
          loaderName={'logoUploaderLoading'}
          success={this.success}
          className={cp.spaceTop3}
        />
      </div>
    );
  }
}

const mapState = (state) => ({
  logoUploaderLoading: state.loader.logoUploaderLoading
});

const mapDispatch = {
  doRemoveLogo,
  doUploadLogo,
  setLoaderStart,
  setLoaderComplete,
  demoRestriction
};

export default compose(
  injectIntl,
  withStyles(cp, s),
  connect(mapState, mapDispatch),
  withQuery(gql`
          query getLogo{
            getLogo {
            id
          title
          name
          value
          type
        }
      }
          `, {
    name: 'getLogoData',
    options: {
      ssr: false
    }
  }),
)(Uploader);